export default __webpack_public_path__ + "dist/krypta/main.min.css";